import type React from "react";
import Seo from "../components/Seo";

const Contact: React.FC = () => {
  return (
    <div
      className="relative"
      style={{
        backgroundImage: "url('/images/contact.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "min(100vh, 800px)",
      }}
    >
      <Seo
        title="Contact Us"
        description="Get in touch with Cycle Collective Saskatoon. Call or text (639) 295-4557 or email info@cyclecollective.ca. Visit us at 2710 Lorne Avenue."
        path="/contact"
        image="/images/contact.jpg"
      />
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-black/30" />

      <div className="container mx-auto px-4 py-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Left Side - Contact Info */}
          <div className="flex flex-col justify-center text-white">
            <h1 className="text-4xl md:text-5xl font-bold mb-8 drop-shadow-lg">
              We can't wait to connect with you!
            </h1>
            <div className="space-y-4">
              <p className="text-lg drop-shadow-md">info@cyclecollective.ca</p>
              <p className="text-lg drop-shadow-md">
                (639) 295-4557 (call or text)
              </p>
            </div>
          </div>

          {/* TODO: Re-enable contact form once Web3Forms is set up */}
        </div>
      </div>
    </div>
  );
};

export default Contact;
